import React from 'react';
import { InlineWidget } from 'react-calendly';
import { useSelector } from 'react-redux';

const StepFive = () => {
  const user = useSelector(state => state.user);
  const quiz = useSelector(state => state.quiz);
  return (
    <>
      {quiz.calendlyUrl &&
        <InlineWidget
          url={`${quiz.calendlyUrl}?hide_event_type_details=1`}
          prefill={{
            name: user.firstName + ' ' + user.lastName,
            email: user.email,
            customAnswers: {
              a1: user.phone,
              a2: user.centerName
            }
          }}
          style={{height: '773px'}}
        />
      }
    </>
  )
}

export default StepFive
